import React from 'react'
import { connect } from 'react-redux'
import toLower from 'lodash/toLower'

import AttractionActions from '../../Redux/AttractionRedux'

class AttractionResetUpdate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      tab: null,
      form: {
        language_code: toLower(props.setting.language_code),
        highlights: '',
        additional_info: '',
        description: ''
      },
      files: {},
      showModal: null,
      selected: {
        item: {},
        dimension: null,
        banner: null
      }
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      form: {
        ...this.state.form,
        highlights: nextProps.attraction.detail.highlights,
        additional_info: nextProps.attraction.detail.additional_info,
        description: nextProps.attraction.detail.description
      }
    })
  }

  componentDidMount = () => {
    let filter = {
      language_code: this.props.setting.language_code,
      currency_code: this.props.setting.currency_code
    }
    let data = {
      id: this.props.detailId,
      filter
    }
    this.props.getAttractionDetail(data)
  }

  _submit = () => {
    const form = {
      is_ignored_on_update: false
    }
    const data = {
      id: this.props.attraction.detail.id,
      form
    }
    this.props.updateAttractionDetail(data)
    this.props.closeModal()
  }

  render () {
    const { fetching, err, processing } = this.props.attraction

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>
            Reset Attraction ?
            {(fetching || processing) && <div className='badge badge-info ml-2'>{fetching ? 'Loading' : 'Processing'} ...</div>}
          </h4>
        </div>
        {err && <div className='alert alert-danger'>{err}</div>}
        <div className='form-group text-center'>
          <p>*The reset will take time, need to wait the CRON to process</p>
        </div>
        <div className='form-group text-center'>
          <button className='btn btn-lg btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
          <button className='btn btn-lg btn-primary ml-2' onClick={() => this._submit()}>Reset</button>
        </div>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  attraction: state.attraction
})

const dispatchToProps = (dispatch) => ({
  getAttractionDetail: (data) => dispatch(AttractionActions.attractionDetailRequest(data)),
  updateAttractionDetail: (data) => dispatch(AttractionActions.attractionUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(AttractionResetUpdate)



// WEBPACK FOOTER //
// ./src/Containers/Attraction/AttractionResetUpdate.js